export const MSG_INSUFFICIENT =
    'Selected account does not have enough funds to cover the order, or the trading limit has been exceeded.';

export const CUSTOM_ERROR_MESSAGES: Record<string, string> = {
    ERR_ORDER_TYPE_NOT_TRADABLE: 'This order configuration is not allowed. Please change Market Session or Order Type.',
    ERR_TOO_EARLY_TO_ENTER: 'It is too early to enter this order. Please change Market Session or Order Type.',
    ERR_TOO_LATE_TO_ENTER: 'It is too late to enter this order. Please change Market Session or Order Type.',
    ERR_STOP_GREATER_LAST:
        'The stop price must be at or below the last traded price for this order. Please adjust the stop price.',
    ERR_STOP_LESS_LAST:
        'The stop price must be above the last traded price for this order. Please adjust the stop price.',
    ERR_GTC_NOT_ALLOWED:
        'Good Till Cancelled (GTC) is not allowed. Please choose a different duration (e.g. Good for Day).',
    ERR_NON_CORE_DISALLOWED: 'Only Core Market session is allowed for this order. Please select Core Market hours.',
    ERR_ORDER_VALUE_TOO_SMALL:
        'The order value is below the minimum allowed. Please increase the quantity or order value.',
    ERR_UNALLOCATED_ORDERS:
        'This order cannot be placed: the symbol has unallocated orders that must be allocated first. Please allocate them, then try again.',
    ERR_DUPLICATE_ORDER_SUBMISSION:
        'This order has already been submitted. Please wait before submitting again or check your open orders.',
    ERR_NO_GTC_ON_INET:
        'Good Till Cancelled (GTC) is not allowed for this market session. Please choose a different duration (e.g. Good for Day) or a different market session.',
    ERR_TOO_SMALL_FOR_AON:
        "The order quantity is too small to be placed as 'All or None'. Please increase the quantity or select a different fill type.",
    ERR_INSUFFICIENT_FUNDS: MSG_INSUFFICIENT,
    ERR_INSUFFICIENT_CASH: MSG_INSUFFICIENT,
    WARN_ESTABLISHING_MARGIN_DEBIT: 'This order is going to establish a margin debit on the selected account',
};
